import React from 'react';
import {
  createStyles,
  makeStyles,
  Theme,
  useTheme,
} from '@material-ui/core/styles';
import Popover from '@material-ui/core/Popover';
import Grid from '@material-ui/core/Grid';
import Box from '@material-ui/core/Box';
import CloseIcon from '@material-ui/icons/Close';
import IconButton from '@material-ui/core/IconButton';
import { useTranslation } from '../../../../hooks/useTranslation';

type Props = {
  isOpen: boolean;
  closeTooltip: () => void;
  anchorEl: HTMLElement | null;
  content: React.ReactNode;
};

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    closeBtn: {
      position: 'absolute',
      top: 8,
      right: 8,
      padding: 0,
    },
  }),
);

const EmancipatedMinorTooltip = ({
  isOpen,
  anchorEl,
  closeTooltip,
  content,
}: Props) => {
  const { t } = useTranslation();
  const theme = useTheme();
  const classes = useStyles();

  return (
    <Popover
      open={isOpen}
      anchorEl={anchorEl}
      onClose={closeTooltip}
      sx={{
        pointerEvents: 'none',
      }}
      anchorOrigin={{
        vertical: 'top',
        horizontal: 'left',
      }}
      transformOrigin={{
        vertical: 'bottom',
        horizontal: 'left',
      }}
      PaperProps={{
        style: {
          maxWidth: 350,
        },
      }}
      disableRestoreFocus
    >
      <Grid container spacing={0} direction="row-reverse">
        <Grid item>
          <IconButton onClick={closeTooltip} className={classes.closeBtn}>
            <CloseIcon />
          </IconButton>
          <Box padding={`${theme.spacing(4)}px ${theme.spacing(3)}px`}>
            {content}
          </Box>
        </Grid>
      </Grid>
    </Popover>
  );
};

export default EmancipatedMinorTooltip;
